import { axiosAuthInstance } from "./instance";

const getAppToken = () => {
  return axiosAuthInstance.post("/oauth/token", {
    grant_type: "client_credentials",
    client_id: process.env.REACT_APP_PUBLIC_CLIENT_ID_LOGIN,
    client_secret: process.env.REACT_APP_PUBLIC_CLIENT_SECRET_LOGIN,
  });
};

const getAppPQRToken = () => {
  return axiosAuthInstance.post("/oauth/token", {
    grant_type: "client_credentials",
    client_id: process.env.REACT_APP_PUBLIC_CLIENT_ID_PQR,
    client_secret: process.env.REACT_APP_PUBLIC_CLIENT_SECRET_PQR,
  });
};

export { getAppToken, getAppPQRToken };
